export default __webpack_public_path__ + "static/picEvenements-ee79a2bb5aa885971b45bc9c93ffa7d2.jpg";